<template>
  <div class="warpper">
    <div class="warpper_reply">
      <div class="reply_header line_bottom">
        <div class="title">督办待回复</div>
        <div class="info">
            <div>督办人:</div>
            <div>{{list.superviseUserName}}</div>
        </div>
        <div class="info infoBottom">
            <div>督办级别:</div>
            <div>{{list.typeLevelValue}}</div>
        </div>
      </div>
      <div class="content_tile">回复内容</div>
      <div class="content">
          <textarea placeholder="请在这里填写回复督办人的信息" class="txt" v-model="reason"></textarea>
      </div>
      <div class="btn" :class="{'active':change}" @click="submit">提交</div>
    </div>
    <div class="warpper_info">
      <div class="info_box"></div>
       <div class="reject">
            <div class="reject_item" @click="goDetail">
                <div class="status line_bottom">
                    <p class="info_text">原投诉单信息</p>
                    <p>
                        <span class="info_text1">查看详情</span>
                        <span>
                            <img src="../../assets/image/right.png" alt="">
                        </span>
                    </p>
                </div>
                <div class="box_item">
                    <div class="info info1">
                        <span>投诉对象:</span>
                        <span>{{list.defendantName}}</span>
                    </div>
                    <div class="info">
                        <span>投诉人:</span>
                        <span>{{list.complainName}}</span>
                    </div>
                    <div class="info">
                        <span>投诉时间:</span>
                        <span>{{list.complainTime}}</span>
                    </div>
                    <div class="info">
                        <span>投诉单号:</span>
                        <span>{{list.complainNumber}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
    import api from '../../service/modules/complaintApis'
    import util from '@/utils/common';
    export default {
        name: 'todoDetails',
        data () {
            return {
                list: '',
                reason: '',
                item:util.getJsonLocal('item')

            }
        },
        computed: {
            change () {
                if (this.reason.trim().length > 0) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        created () {
            this.list = util.getJsonLocal('item')
        },
        // beforeCreate () {
        //     this.list = util.removeJsonLocal('item')
        // },
        mounted () {
        },
        methods: {
            goDetail(){
                this.$set(this.item,'btns',[])
                util.setJsonLocal('item',this.item);
                this.$router.push('/complaint/detailList');
            },
            submit () {
                const data = {
                    id: this.item.id,
                    replyContent: this.reason
                }
                api.worker.superviseReply(data).then((res) => {
                    if (res.ret === 0) {
                        this.$Toast.loading({
                            message: '提交成功',
                            icon: 'passed',
                            forbidClick: true
                        });
                        yyn.invokeJSB('closeWindow')
                    }
                    
                })
            }
        }
    }
</script>
<style lang="less" scoped>
.warpper {
  background: #fff;
  height: 100%;
  .warpper_reply {
    padding: 24px 12px;
    .reply_header {
      .title {
        font-size:16px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:bold;
        color:rgba(51,51,51,1);
        line-height:16px;
        margin-bottom: 16px;
      }
      .info {
        margin-top: 12px;
        display: flex;
        font-size: 14px;
        color: #666666;
        line-height: 22px;
        div:nth-child(1) {
            width: 70px;
        }
        div:nth-child(2) {
            width: 277px;
            word-break: break-all;
        }
      }
      .infoBottom {
        padding-bottom: 16px;
        margin-top: 0px;
      }
    }
    .content_tile {
      font-size:14px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(153,153,153,1);
      line-height:14px;
      margin: 23px 0 12px;
    }
    .content{
        width:100%;
        height:180px;
        .txt{
            width:100%;
            height:100%;
            border: 0;
            outline:none;
            resize: none;
            background-color: #F9F9F9;
            padding:16px;
            font-size: 14px;
            box-sizing: border-box;
        }
    }
    .btn{
        width:100%;
        height:50px;
        text-align: center;
        line-height: 50px;
        color:#fff;
        background:rgba(54, 179, 116, .3);
        margin-top:24px;
        font-size:16px;
        border-radius: 3px;
    }
    .active{
        background:rgb(54, 179, 116);
    }
  }
  .warpper_info {
      .reject {
          width: 100%;
          padding-bottom: 16px;
          .reject_item {
              margin:0 12px;
              box-sizing: border-box;
              background-color: #fff;
              padding-bottom: 0;
              box-shadow: 0px 5px 20px 5px rgba(0, 0, 0, 0.06);
              border-radius: 3px;
              .box_item{
                  width:100%;
                  padding: 15px 16px 16px;
                  box-sizing: border-box;
                  .info {
                      margin-top: 12px;
                      span:nth-child(1) {
                          display: inline-block;
                          width: 60px;
                          margin-right: 4px;
                          font-size: 14px;
                          color: #666666;
                      }
                      span:nth-child(2) {
                          display: inline-block;
                          font-size: 12px;
                      }
                      span {
                          font-size: 12px;
                          color: #666666;

                      }
                  }
                  .info1 {
                    margin-top: 0px;
                  }
              }
              .status {
                  width: 100%;
                  padding: 16px;
                  box-sizing: border-box;
                  font-size: 14px;
                  color: #666666;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  .info_text{
                      font-size:14px;
                      color: #2A2A2A;
                      font-weight: bold;
                  }
                  p:nth-child(2) {
                      display: flex;
                      align-items: center;
                      span {
                          color: #999999;
                          font-size: 12px;
                      }
                      .info_text1{
                          font-size:12px;
                      }
                  }
                  p>span>img {
                      width: 4px;
                      height: 7px;
                      margin-left: 4px;
                      margin-top:-3px;
                  }
              }
          }
      }
  }
}
</style>
